module.exports = __webpack_public_path__ + "static/media/mobile_music.c976d118.png";